/* eslint-disable @typescript-eslint/no-explicit-any */
type EventMap = Map<string, ((args: any) => void)[]>;
/**
 * Pass an initial state to the constructor. This is then used to setup a state-manager
 * with events for each individual state key that can be added listeners to
 */
class EventEmitter<T extends Record<string, unknown>> {
  private listeners: EventMap;
  public state: T = {} as T;

  constructor(initialState: T) {
    this.listeners = new Map();
    Object.assign(this.state, initialState);
  }

  // Allow the user to call set as a key value pair ...
  public set(key: keyof T, value: T[keyof T]) {
    this.state[key] = value;
    this.emit(key as string, value);
  }

  // ...or as an object
  public batch(obj: Partial<T>) {
    Object.entries(obj).forEach(([k, v]) => {
      this.set(k, v);
    });
  }

  public on = (event: string, callback: (args: any) => void): void => {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event)?.push(callback);
  };

  public off = (event: string, callback: (args: any) => void): void => {
    if (this.listeners.has(event)) {
      const listeners = this.listeners.get(event)!;
      const index = listeners.indexOf(callback);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  };

  public emit = (event: string, args: any): void => {
    if (this.listeners.has(event)) {
      const listeners = this.listeners.get(event)!;
      for (const listener of listeners) {
        listener(args);
      }
    }
    if (this.listeners.has("*")) {
      const listeners = this.listeners.get("*")!;
      for (const listener of listeners) {
        listener(this.state);
      }
    }
  };
}

export default EventEmitter;
